import ProducerDetailsBalances from './ProducerDetailsBalances';

export default ProducerDetailsBalances;
